export default {
  LOCAL_STORAGE_KEYS: {
    ensManagerStore: 'ens-manager-store'
  },
  VERSION: {
    ensManagerStore: '0.0.1'
  }
};
